<template>
  <div class="mb-3">
    <label v-if="getTitle">
      {{ getTitle }}
      <w-tooltip v-if="tooltipContent && tooltipContent.length">{{ tooltipContent }}</w-tooltip>
    </label>

    <textarea
      ref="input"
      style="overflow: hidden"
      :disabled="disabled"
      :readonly="model.$schema.readOnly"
      :value="svalue"
      :class="classObject"
      :placeholder="placeholder"
      :name="model.$form.testPath ? model.$path : undefined"
      @input="onInput($event)"
      @blur="onTextareaBlur($event)"
      @focus="onTextareaFocus($event)"
      @mouseover="mouseOver($event)"
      @mouseleave="mouseOut($event)"
    ></textarea>

    <textarea v-if="useHelper" ref="hresize" class="form-control areahelper" style="overflow: hidden" tabindex="-1"></textarea>

    <div v-if="model.$schema.maxLength !== undefined" class="text-note text-muted">
      <small :class="{'text-danger': !model.$hasFocus && length > model.$schema.maxLength}">{{ length }} z {{ model.$schema.maxLength || 0 }}</small>
    </div>

    <w-error :model="model" @focus="$refs.input.focus()"></w-error>
  </div>
</template>

<script>
import modelMixin from '../mixins/modelMixin';

import WError from './error.vue';
import WTooltip from './tooltip.vue';

export default {
  name: 'w-textarea',
  props: {
    placeholder: String,
    appendicon: {
      type: String,
      default: ''
    },
    prependicon: {
      type: String,
      default: ''
    }
  },
  mixins: [modelMixin],
  components: {WError, WTooltip},
  data() {
    return {
      length: 0,
      useHelper: false
    };
  },
  mounted() {
    this.$watch('svalue', {
      handler(newValue) {
        this.resize(newValue);
      }
    });
  },

  computed: {
    classObject() {
      const result = ['form-control'];
      if (this.borderless) {
        result.push('borderless');
        if (this.useHelper) {
          result.push('active');
        }
      }
      if (this.model.$error) {
        result.push('is-invalid');
      }

      return result;
    }
  },
  methods: {
    // Ustawia wielkość text-area
    resize(newValue, blur) {
      if (newValue === undefined) {
        if (this.svalue === undefined) {
          newValue = '';
        } else {
          newValue = this.svalue;
        }
      }

      this.length = (newValue || '').length || 0;

      let newHeight = 0;
      if (this.useHelper) {
        if (this.$refs.hresize === undefined) {
          return;
        }
        if (blur) {
          return;
        }

        this.$refs.hresize.value = newValue + 'aaa';
        const height = this.$refs.hresize.scrollHeight;
        newHeight = height + 2;
      } else {
        if (this.$refs.input === undefined) {
          return;
        }
        newHeight = this.$refs.input.scrollHeight + 2;
      }

      this.$refs.input.style.overflow = 'hidden';
      this.$refs.input.style.height = newHeight + 'px';
    },
    // Ustawia helper przy focus
    onTextareaFocus(evt) {
      this.useHelper = true;
      this.onFocus(evt);
    },
    // Ustawia helper przy blur
    onTextareaBlur(evt) {
      this.useHelper = false;
      this.onBlur(evt);
    }
  }
};
</script>

<style>
textarea.areahelper {
  position: absolute;
  top: -9999px;
  left: -9999px;
}
textarea.active {
  background-color: lightyellow !important;
}
</style>
